module.exports = __webpack_public_path__ + "media/images/athletes/3545-6d735eb674cf507460c31f260828dbc3.png";